import { MyBidsComponent } from './pages/my-bids/my-bids.component';
import { AccountPayComponent } from './pages/account-pay/account-pay.component';
import { SupportCenterComponent } from './pages/support-center/support-center.component';
import { OrdersDetailsComponent } from './pages/orders-details/orders-details.component';
import { MyEnquiriesComponent } from './pages/my-enquiries/my-enquiries.component';
import { MyFavouritesComponent } from './pages/my-favourites/my-favourites.component';
import { MembershipComponent } from './pages/membership/membership.component';
import { MyAddressComponent } from './pages/my-address/my-address.component';
import { MyOrdersComponent } from './pages/my-orders/my-orders.component';
import { ProfileDetailsComponent } from './pages/profile-details/profile-details.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileListingComponent } from './pages/profile-listing/profile-listing.component';
import { SuppliesOrdersResolver } from './resolvers/supplies-orders.resolver';
import { MyEnquiriesDetailsComponent } from './pages/my-enquiries-details/my-enquiries-details.component';
import { GetSupplyEnquiriesResolver } from './resolvers/get-supply-enquiries.resolver';
import { MyPreOwnedOrdersComponent } from './pages/my-pre-owned-orders/my-pre-owned-orders.component';
import { ListingComponent } from '../dashboard/modules/pre-owned-orders/pages/listing/listing.component';
import { PreOwnedOrdersDetailsComponent } from './pages/pre-owned-orders-details/pre-owned-orders-details.component';
import { SecondHandSuppliesOrdersResolver } from './resolvers/second-hand-supplies-orders.resolver';
import { FeedComponent } from '../feeds/pages/feed/feed.component';
import { JobListingComponent } from './pages/job-listing/job-listing.component';
import { JobPostComponent } from './pages/job-post/job-post.component';
import { ApplicantDetailsComponent } from './pages/applicant-details/applicant-details.component';
import { AddNewsfeedCategoryComponent } from '../feeds/pages/add-newsfeed-category/add-newsfeed-category.component';
import { ListNewsfeedCategoryComponent } from '../feeds/pages/list-newsfeed-category/list-newsfeed-category.component';
import { FollowListingComponent } from './pages/follow-listing/follow-listing.component';
import { ListJobRoleComponent } from '../feeds/pages/list-job-role/list-job-role.component';
import { AddJobRoleComponent } from '../feeds/pages/add-job-role/add-job-role.component';
import { ListEmployeeTypeComponent } from '../feeds/pages/list-employee-type/list-employee-type.component';
import { AddEmployeeTypeComponent } from '../feeds/pages/add-employee-type/add-employee-type.component';
import { AppliedJobsListingComponent } from './pages/applied-jobs-listing/applied-jobs-listing.component';
import { TalentListingComponent } from './pages/talent-listing/talent-listing.component';
import { EnquiriesJobsListingComponent } from './pages/enquiries-jobs-listing/enquiries-jobs-listing.component';
import { ModulesPermissionGuard } from 'src/app/core/guards/ModulesPermissionGuard';
import { CourseListingComponent } from './pages/course-listing/course-listing.component';
import { CoursePostComponent } from './pages/course-post/course-post.component';
import { CourseRegisterComponent } from './pages/course-register/course-register.component';
import { RegisteredCourseComponent } from './pages/registered-course/registered-course.component';
import { TalentEnquiriesComponent } from './pages/talent-enquiries/talent-enquiries.component';
import { JobApplicantsComponent } from './pages/job-applicants/job-applicants.component';
import { JoinRequestComponent } from './pages/join-request/join-request.component';
import { PartnershipRequestComponent } from './pages/partnership-request/partnership-request.component';
import { MembershipRegistrationComponent } from './pages/membership-registration/membership-registration.component';
import { PartnershipRegistrationComponent } from './pages/partnership-registration/partnership-registration.component';
// import { PartnershipRegistrationComponent } from './pages/partnership-registration/partnership-registration.component';
//import { ApplicantInfoComponent } from '../jobseek/pages/applicant-info/applicant-info.component';


const routes: Routes = [
  {
    path: '',
    component: ProfileListingComponent,
    children: [
      {
        path: '',
        redirectTo: 'detail',
        pathMatch: 'prefix'
      },
      {
        path: 'detail',
        component: ProfileDetailsComponent
      },
      {
        path: 'my-dashboard',
        component: FeedComponent
      },
      {
        path: 'community-feed/:id',
        component: FeedComponent
      },
      {
        path: 'join-request',
        component: JoinRequestComponent
      },
      {
        path: 'partnership-request',
        component:PartnershipRequestComponent
      },
      {
        path: 'membership-registration/:id',
        component:MembershipRegistrationComponent
      },
    
      {
        path: 'partnership-registration/:id',
        component:PartnershipRegistrationComponent
      },
    
      {
        path: 'list-newsfeeds',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'news_feed_modules_permission' },
        component: ListNewsfeedCategoryComponent,
      },
      {
        path: 'list-newsfeeds-catagory/:communityId',
        component: ListNewsfeedCategoryComponent,
      },
      {
        path: 'follow-user-list',
        component: FollowListingComponent
      },

      {
        path: 'add-newsfeeds',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'news_feed_modules_permission' },
        component: AddNewsfeedCategoryComponent
      },
      {
        path: 'add-newsfeeds/:communityId',
        component: AddNewsfeedCategoryComponent,
      },
      {
        path: 'list-newsfeed-category/edit/:id',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'news_feed_modules_permission' },
        component: AddNewsfeedCategoryComponent
      },

      // job corner
      {
        path: 'job-listing',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: JobListingComponent
      },
      {
        path: 'job-listing/applicants/:id/:status',
        component: JobApplicantsComponent
      },
      {
        path: 'talent-listing',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: TalentListingComponent
      },
      {
        path: 'talent-enquiries',
        component: TalentEnquiriesComponent
      },


      {
        path: 'job-role-listing',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: ListJobRoleComponent
      },
      {
        path: 'job-role-listing-role/edit/:id',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: AddJobRoleComponent
      },
      {
        path: 'add-job-role',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: AddJobRoleComponent
      },

      {
        path: 'list-employee-type',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: ListEmployeeTypeComponent
      },
      {
        path: 'list-employee-type-edit/edit/:id',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: AddEmployeeTypeComponent
      },
      {
        path: 'add-employee-type',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: AddEmployeeTypeComponent
      },

      {
        path: 'job-post',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: JobPostComponent
      },
      {
        path: 'list-job-post/edit/:id',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'job_seek_modules_permission' },
        component: JobPostComponent
      },
      {
        path: 'applied-job-listing',

        component: AppliedJobsListingComponent
      },
      {
        path: 'enquiries-job-listing',
        component: EnquiriesJobsListingComponent
      },


      // {
      //   path: 'applicant-info',
      //   component: ApplicantInfoComponent
      // },
      {
        path: 'reports',
        loadChildren: () => import('src/app/modules/dashboard/modules/reports/reports.module').then((m) => m.ReportsModule)
      },
      {
        path: 'orders',
        component: MyOrdersComponent
      },
      {
        path: 'orders/:id',
        component: OrdersDetailsComponent,
        resolve: {
          oldSupplierOrder: SuppliesOrdersResolver
        }
      },


      {
        path: 'my-pre-owned-orders',
        component: MyPreOwnedOrdersComponent
      },
      {
        path: 'my-pre-owned-orders/:id',
        component: PreOwnedOrdersDetailsComponent,
        resolve: {
          oldSecondHandSuppliesOrders: SecondHandSuppliesOrdersResolver
          //   oldSupplierOrder: PreOwnedOrdersDetailsComponent
        }
      },
      {
        path: 'course-listing',
        // canActivate: [ModulesPermissionGuard],
        // data: { permissionKey: 'job_seek_modules_permission' },        
        component: CourseListingComponent
      },
      {
        path: 'course-listing/registered/:id',
        component: CourseRegisterComponent
      },

      {
        path: 'registered-course',
        component: RegisteredCourseComponent,
      },

      {
        path: 'course-post',
        // canActivate: [ModulesPermissionGuard],
        // data: { permissionKey: 'job_seek_modules_permission' },        
        component: CoursePostComponent
      },
      {
        path: 'course-post/edit/:id',
        // canActivate: [ModulesPermissionGuard],
        // data: { permissionKey: 'job_seek_modules_permission' },        
        component: CoursePostComponent
      },



      // my order //
      {
        path: 'my-orders',
        loadChildren: () => import('src/app/modules/dashboard/modules/my-orders/my-orders.module').then((m) => m.MyOrdersModule)
      },

      // new //
      {
        path: 'pre-owned-orders',
        loadChildren: () => import('src/app/modules/dashboard/modules/pre-owned-orders/pre-owned-orders.module').then((m) => m.PreOwnedOrdersModule)
      },
      {
        path: 'supplies',
        loadChildren: () => import('src/app/modules/dashboard/modules/my-supplies/my-supplies.module').then((m) => m.MySuppliesModule)
      },
      {
        path: 'pre-owned-supplies',
        loadChildren: () => import('src/app/modules/dashboard/modules/pre-owned-supplies/pre-owned-supplies.module').then((m) => m.PreOwnedSuppliesModule)
      },
      {
        path: 'coupons',
        loadChildren: () => import('src/app/modules/dashboard/modules/coupon/coupon.module').then((m) => m.CouponModule)
      },
      {
        path: 'supply-deals',
        loadChildren: () => import('src/app/modules/dashboard/modules/supply-deals/supply-deals.module').then((m) => m.SupplyDealsModule)
      },
      {
        path: 'catalogues',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'catalogues_modules_permission' },
        loadChildren: () => import('src/app/modules/dashboard/modules/my-catalogues/my-catalogues.module').then((m) => m.MyCataloguesModule)
      },
      {
        path: 'directory',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'directory_minimal_permission' },
        loadChildren: () => import('src/app/modules/dashboard/modules/my-directory/my-directory.module').then((m) => m.MyDirectoryModule)
      },
      {
        path: 'directory-business-types',
        loadChildren: () => import('src/app/modules/dashboard/modules/directory-business-types/directory-business-types.module').
          then((m) => m.DirectoryBusinessTypesModule)
      },
      {
        path: 'enquiries-management',
        loadChildren: () => import('src/app/modules/dashboard/modules/enquiries-management/enquiries-management.module').then((m) => m.EnquiriesManagementModule)
      },
      {
        path: 'support-management',
        loadChildren: () => import('src/app/modules/dashboard/modules/support-management/support-management.module').then((m) => m.SupportManagementModule)
      },
      {
        path: 'freight-ranges',
        loadChildren: () => import('src/app/modules/dashboard/modules/freight-ranges/freight-ranges.module').then((m) => m.FreightRangesModule)
      },
      {
        path: 'account-pay-requests',
        loadChildren: () => import('src/app/modules/dashboard/modules/account-pay-requests/account-pay-requests.module').then((m) => m.AccountPayRequestsModule)
      },
      {
        path: 'price-units',
        loadChildren: () => import('src/app/modules/dashboard/modules/price-units/price-units.module').then((m) => m.PriceUnitsModule)
      },
      {
        path: 'supply-categories',
        loadChildren: () => import('src/app/modules/dashboard/modules/supply-categories/supply-categories.module').then((m) => m.SupplyCategoriesModule)
      },
      {
        path: 'supply-sub-categories',
        loadChildren: () => import('src/app/modules/dashboard/modules/supply-sub-categories/supply-sub-categories.module').then((m) => m.SupplySubCategoriesModule)
      },
      {
        path: 'supply-brands',
        loadChildren: () => import('src/app/modules/dashboard/modules/supply-brands/supply-brands.module').then((m) => m.SupplyBrandsModule)
      },
      {
        path: 'clients',
        loadChildren: () => import('src/app/modules/dashboard/modules/clients/clients.module').then((m) => m.ClientsModule)
      },
           {
        path: 'admin',
        loadChildren: () => import('src/app/modules/dashboard/modules/admin/admin.module').then((m) => m.AdminModule)
      },
      {
        path: 'subscription-plans',
        loadChildren: () => import('src/app/modules/dashboard/modules/subscription-plans/subscription-plans.module').then((m) => m.SubscriptionPlansModule)
      },
      {
        path: 'directory-business-types',
        loadChildren: () => import('src/app/modules/dashboard/modules/directory-business-types/directory-business-types.module').
          then((m) => m.DirectoryBusinessTypesModule)
      },
      {
        path: 'directory-categories',
        loadChildren: () => import('src/app/modules/dashboard/modules/directory-categories/directory-categories.module').then((m) => m.DirectoryCategoriesModule)
      },
      {
        path: 'catalogue-categories',
        loadChildren: () => import('src/app/modules/dashboard/modules/catalogue-categories/catalogue-categories.module').then((m) => m.CatalogueCategoriesModule)
      },

      {
        path: 'course-categories',
        loadChildren: () => import('src/app/modules/dashboard/modules/course-categories/course-categories.module').then((m) => m.CourseCategoriesModule)
      },

      {
        path: 'dental-supplier-supply-settings',
        loadChildren: () => import('src/app/modules/dashboard/modules/dental-supplier-supply-settings/dental-supplier-supply-settings.module').then((m) => m.DentalSupplierSupplySettingsModule)
      },
      {
        path: 'support-request-reasons',
        loadChildren: () => import('src/app/modules/dashboard/modules/support-request-reasons/support-request-reasons.module').then((m) => m.SupportRequestReasonsModule)
      },
      {
        path: 'states',
        loadChildren: () => import('src/app/modules/dashboard/modules/states/states.module').then((m) => m.StatesModule)
      },
      {
        path: 'suburbans',
        loadChildren: () => import('src/app/modules/dashboard/modules/suburbans/suburbans.module').then((m) => m.SuburbansModule)
      },
      {
        path: 'broadcasts',
        loadChildren: () => import('src/app/modules/dashboard/modules/broadcasts/broadcasts.module').then((m) => m.BroadcastsModule)
      },
      {
        path: 'banners',
        canActivate: [ModulesPermissionGuard],
        data: { permissionKey: 'banner_modules_permission' },
        loadChildren: () => import('src/app/modules/dashboard/modules/banners/banners.module').then((m) => m.BannersModule)
      },
      // new end//
      {
        path: 'address',
        component: MyAddressComponent
      },
      {
        path: 'membership',
        component: MembershipComponent
      },
      {
        path: 'favourites',
        component: MyFavouritesComponent
      },
      {
        path: 'enquiries',
        component: MyEnquiriesComponent
      },
      {
        path: 'enquiries/:id',
        component: MyEnquiriesDetailsComponent,
        resolve: {
          oldSupplyEnquiries: GetSupplyEnquiriesResolver
        }
      },
      {
        path: 'support-center',
        component: SupportCenterComponent
      },
      {
        path: 'account-pay',
        component: AccountPayComponent
      },
      {
        path: 'my-bids',
        component: MyBidsComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
